import { render, staticRenderFns } from "./NovoGrupoUsuario.vue?vue&type=template&id=311bfa4e&"
import script from "./NovoGrupoUsuario.vue?vue&type=script&lang=js&"
export * from "./NovoGrupoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports